<script>
import constants from "@/libs/Constants";
import cookieSetterGetter from "@/libs/Cookie";
import OffCanvas from "@/components/OffCanvas.vue";
import {checkUndefinedOrDefaultValue} from '@/libs/Helpers';

export default {
  components: {OffCanvas},
  data() {
    return {
      showCookies: false,
      constants: constants,
      //Configuration from environment
      cookieSetterGetter: cookieSetterGetter,
      cookieName: checkUndefinedOrDefaultValue(process.env.VUE_APP_COOKIES_NAME, 'cookieStore'),
      cookieFlagName: checkUndefinedOrDefaultValue(process.env.VUE_APP_COOKIES_FLAG_NAME, 'privacy')
    }
  },
  methods: {
    onAcceptCookies() {
      this.cookieSetterGetter.setCookie(this.cookieName, this.cookieFlagName);
      this.showCookies = false;
    },
    onCanvasHidden() {
      this.showCookies = false;
    }
  },
  computed: {
    cookieIsSet() {
      let cookiePrivacy = this.cookieSetterGetter.getCookie(this.cookieName);
      return cookiePrivacy !== '' && cookiePrivacy !== undefined && cookiePrivacy !== null;
    }
  },
  beforeMount() {
    this.showCookies = !this.cookieIsSet;
  }
}
</script>
<template>
  <OffCanvas prop-id="cookiesCanvas"
             prop-position="bottom"
             prop-backdrop="false"
             prop-opacity="75"
             :prop-hide-close-button="true"
             :prop-dark="true"
             :prop-show="showCookies"
             :prop-shown="showCookies"
             @on-canvas-hidden="onCanvasHidden">
    <div class="row">
      <div class="col-8 offset-2 text-center">
        <p>{{ $t('cookies.service') }}<br>{{ $t('cookies.browsing') }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-8 offset-2 text-center">
        <router-link
            :to="{name: constants.ROUTING.PRIVACY}"
            role="button"
            target="_blank"
            class="btn btn-outline-light">
          <i class="bi bi-shield-fill-check"></i>
          Privacy Policy
        </router-link>
        <button class="btn btn-light ms-2" @click="onAcceptCookies">
          <i class="bi bi-check2-circle"></i> Ok
        </button>
      </div>
    </div>
  </OffCanvas>
</template>